import { RootState } from '..';

export const selectNameFormValue = (state: RootState) => state.contact.name;
export const selectEMailFormValue = (state: RootState) => state.contact.email;
export const selectDetailsFormValue = (state: RootState) => state.contact.details;

export const selectContactValues = (state: RootState) => ({
    name: state.contact.name.value,
    email: state.contact.email.value,
    details: state.contact.details.value
});
